import { useState } from 'react';
import { Link } from 'react-router-dom';
import Lightbox from '../components/Lightbox';

export default function UdlejningKoeleskabGlas() {
  const [activePhotoIdx, setActivePhotoIdx] = useState(null);
  const images = [
    'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/flaskekoeleskab.jpg'
  ];

  return (
    <div className="flex min-h-screen flex-col bg-stone-50">
      <div className="border-b border-stone-200 bg-white/90 py-4 backdrop-blur">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-2 text-sm text-slate-500">
            <Link to="/" className="transition-colors hover:text-brand-orange">Forside</Link>
            <i className="fa-solid fa-chevron-right text-xs text-stone-300" />
            <Link to="/udlejning" className="transition-colors hover:text-brand-orange">Udlejning</Link>
            <i className="fa-solid fa-chevron-right text-xs text-stone-300" />
            <span className="text-slate-700">Køleskab med glaslåge</span>
          </div>
        </div>
      </div>

      <section className="flex-grow py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 items-start">
            <div className="rounded-[1.75rem] border border-stone-200 bg-white p-8 shadow-[0_12px_30px_rgba(148,163,184,0.08)]">
              <span className="text-xs font-bold uppercase tracking-[0.35em] text-brand-orange">Køl & Varme</span>
              <h1 className="mt-2 mb-6 text-3xl font-semibold text-slate-800">Køleskab med glaslåge</h1>

              <div className="prose prose-slate mb-8 max-w-none text-slate-500 space-y-4">
                <p className="text-base leading-relaxed">
                  Et professionelt flaskekøleskab med glaslåge og indbygget lys, der præsenterer dine kolde drikkevarer på den absolut mest indbydende måde. Perfekt til barområdet i festteltet, firmafester eller private arrangementer.
                </p>
                <div className="rounded-xl bg-stone-50 p-4 border border-stone-100">
                  <span className="block text-xs font-bold uppercase tracking-wider text-slate-400">Pris</span>
                  <span className="text-2xl font-bold text-brand-orange">300 kr. <span className="text-xs text-slate-400 font-normal">(Inkl. moms)</span></span>
                </div>
              </div>

              <div className="border-t border-stone-200 pt-8">
                <h3 className="mb-4 text-lg font-semibold text-slate-800">Kontakt os for leje</h3>
                <div className="flex flex-col gap-4">
                  <a
                    href="tel:22426011"
                    className="inline-flex items-center justify-center gap-3 rounded-full bg-brand-orange px-6 py-3.5 text-base font-bold text-white transition-colors hover:bg-brand-orange-hover"
                  >
                    <i className="fa-solid fa-phone" />
                    <span>22 42 60 11</span>
                  </a>
                  <Link
                    to="/kontakt"
                    className="inline-flex items-center justify-center gap-3 rounded-full border border-stone-200 bg-white px-6 py-3.5 text-base font-bold text-slate-700 transition-colors hover:border-brand-orange hover:text-brand-orange"
                  >
                    <i className="fa-solid fa-envelope" />
                    <span>Forespørg leje</span>
                  </Link>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-4">
              {images.map((src, idx) => (
                <div
                  key={idx}
                  className="h-96 overflow-hidden rounded-[1.5rem] border border-stone-200 bg-white cursor-zoom-in shadow-md"
                  onClick={() => setActivePhotoIdx(idx)}
                >
                  <img
                    src={`https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/${src}`}
                    alt={`Køleskab med glaslåge`}
                    className="h-full w-full object-cover transition-transform duration-300 hover:scale-105"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Lightbox
        images={images}
        currentIndex={activePhotoIdx}
        onClose={() => setActivePhotoIdx(null)}
        onPrev={() => setActivePhotoIdx((prev) => (prev === 0 ? images.length - 1 : prev - 1))}
        onNext={() => setActivePhotoIdx((prev) => (prev === images.length - 1 ? 0 : prev + 1))}
      />
    </div>
  );
}
